<template>
    <Background
        :backPath="'/home'">

        <ListView
            ref="userList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :fetchCallback="fetchUserList"
            :clickCallback="clickDevice"
            :addCallback="addDevice"
            :listWidth="80"
        />

        <div
            v-if="amount > 0"
            class="merchant-amount">
            主控总数: {{ amount }}
        </div>

        <AddDeviceDialog ref="dialog"/>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import ListView from "./ListView.vue"
 import AddDeviceDialog from "./AddDeviceDialog.vue"

 import InputSearch from "ant-design-vue/lib/input/Search";

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import { parseDate } from "../util/date.js"

 Vue.component(InputSearch.name, InputSearch);

 export default {
     name: 'DeviceManage',
     data() {
         return {
             amount: 0,
             searchContent: "",
             searchNumber: 0,
             searching: false,
             titles: ["序号", "主控ID", "主控编号", "主控哈希", "状态", "创建时间"],
             columnWidths: [5, 5, 35, 5, 10, 15],
             columnCells: [
                 { value: "",
                   style: ""
                 },
                 { value: "BoxId",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "BoxSerialNum",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "BoxHasPassword",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "BoxStatus",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "CreatedAt",
                   style: "text-align: end; padding-right: 20px;"
                 },
             ]
         }
     },
     components: {
         Background,
         ListView,
         AddDeviceDialog
     },
     computed: {
     },
     mounted() {
         this.fetchAmount()
     },
     methods: {
         fetchAmount() {
             const url = `${process.env.VUE_APP_API_SERVER}/box/total`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response.Total) {
                     this.amount = response.Total
                 } else {
                     console.log("fetchAmount error: ", response)
                 }
             })
         },
         clickDevice(item) {
             sessionStorage.setItem("clickDeviceInfo", JSON.stringify(item))

             this.$router.push("/deviceInfo")
         },
         addDevice() {
             this.$refs.dialog.show()
         },
         fetchUserList(offset, callback) {
             const url = `${process.env.VUE_APP_API_SERVER}/box?offset=${offset}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log("****** ", response)

                 for (var i=0; i < response.length; i++) {
                     if (response[i].BoxPasswordHash != "") {
                         response[i].BoxHasPassword = "有"
                     } else {
                         response[i].BoxHasPassword = "无"
                     }

                     if (response[i].Status == 0) {
                         response[i].BoxStatus = "入库"
                     } else if (response[i].Status == 2) {
                         response[i].BoxStatus = "测试成功"
                     } else if (response[i].Status == 3) {
                         response[i].BoxStatus = "测试失败"
                     } else if (response[i].Status == 6) {
                         response[i].BoxStatus = "已激活"
                     } else {
                         response[i].BoxStatus = "状态未知 (" + response[i].Status + ")"
                     }

                     response[i].CreatedAt = parseDate(response[i].CreatedAt)
                     response[i].TestedAt = parseDate(response[i].TestedAt)
                 }

                 callback(response)
             })
         },
         onSearch() {
             this.searching = !isEmptyOrWhitespace(this.searchContent)

             if (this.searching) {
                 this.doSearch()
             }
         },
         doSearch() {
             const url = `${process.env.VUE_APP_API_SERVER}/business/search?q=${this.searchContent}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response) {
                     this.searchNumber = response.length
                     this.$refs.searchList.initList(response)
                 } else {
                     this.searchNumber = 0
                     this.$refs.searchList.initList([])
                 }
             })
         },
         cleanSearch() {
             this.searching = false
             this.searchContent = ""
             this.searchNumber = 0

             var that = this
             setTimeout(function () {
                 that.$refs.userList.research()
             }, 100)
         }
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .search-hint-area {
     height: 50px;
 }

 .search-content {
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     color: #666;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .search-hint {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .clean-search {
     background-color: #F9D878;
     color: #666;
     font-size: 16px;
     border-radius: 5px;
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     cursor: pointer;
 }

 .merchant-amount {
     width: 100%;
     margin-top: 10px;
     color: #999;
 }
</style>
